var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloseRoundedFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 16C29 23.1796 23.1796 29 16 29C8.82029 29 3 23.1796 3 16C3 8.82029 8.82029 3 16 3C23.1796 3 29 8.82029 29 16ZM12.0605 12.0605C12.4413 11.6798 13.0586 11.6798 13.4394 12.0605L16 14.6211L18.5605 12.0606C18.9412 11.6798 19.5586 11.6798 19.9394 12.0606C20.3202 12.4413 20.3202 13.0587 19.9394 13.4394L17.3788 16L19.9394 18.5605C20.3202 18.9412 20.3202 19.5586 19.9394 19.9394C19.5586 20.3202 18.9412 20.3202 18.5605 19.9394L16 17.3789L13.4394 19.9394C13.0586 20.3202 12.4413 20.3202 12.0605 19.9394C11.6798 19.5586 11.6798 18.9412 12.0605 18.5606L14.6211 16L12.0605 13.4394C11.6797 13.0586 11.6797 12.4413 12.0605 12.0605Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseRoundedFilled);
export default __webpack_public_path__ + "static/media/icon-close-rounded-filled.0305cd244b59823b7b426d4eb99a9212.svg";
export { ForwardRef as ReactComponent };